var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamicView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24.1509C48.5 37.4891 37.7548 48.3019 24.5 48.3019C11.2452 48.3019 0.5 37.4891 0.5 24.1509C0.5 10.8127 11.2452 0 24.5 0C37.7548 0 48.5 10.8127 48.5 24.1509Z",
    fill: "#359EFF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24.1509C48.5 37.4891 37.7548 48.3019 24.5 48.3019C11.2452 48.3019 0.5 37.4891 0.5 24.1509C0.5 10.8127 11.2452 0 24.5 0C37.7548 0 48.5 10.8127 48.5 24.1509Z",
    stroke: "#030E31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.47C15.5 23.47 18.7727 16.9246 24.5 16.9246C30.2273 16.9246 33.5 23.47 33.5 23.47C33.5 23.47 30.2273 30.0155 24.5 30.0155C18.7727 30.0155 15.5 23.47 15.5 23.47Z",
    stroke: "#353E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5004 25.9245C25.8561 25.9245 26.955 24.8255 26.955 23.4699C26.955 22.1143 25.8561 21.0154 24.5004 21.0154C23.1448 21.0154 22.0459 22.1143 22.0459 23.4699C22.0459 24.8255 23.1448 25.9245 24.5004 25.9245Z",
    stroke: "#353E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicView);
export default __webpack_public_path__ + "static/media/dynamic_view.ab4e96193fef5274d260948cef2f1cf8.svg";
export { ForwardRef as ReactComponent };